// assets/nd-quote-final.js
// v13c - Final 完全由 GAS 決定 quotation_no（依 customer_code 連號）。
// 流程：
//   1) 按下「Export file / Export your quote」按鈕 → 本檔在捕獲階段先呼叫 GAS saveFinalQuote_。
//   2) GAS 存入 Sheet，依 customer_code 算出新的 TESTID-00047 之類的號碼，回傳 JSON。
//   3) 本檔把 data.quotation_no 寫入：
//        - window.ND_QUOTE_FINAL_INFO.quotation_no
//        - window.ND_QUOTE_SERIAL_FULL
//        - window.ND_LAST_FINAL_QUOTE
//   4) 等 GAS 完成後，再程式觸發一次 click，讓 nd-export.js / 其他 Export 腳本執行，
//      這時已經有正式 quotation_no，PDF / XLSX 會用同一個號碼做 Quotation # 與檔名。

(function () {
  if (window.__ND_QUOTE_FINAL_V13C__) return;
  window.__ND_QUOTE_FINAL_V13C__ = true;

  console.info('[ND Quote Final] script v13c loaded (server-side numbering + click gating)');

  /* ---------------- 基本設定：GAS URL / API KEY ---------------- */

  var ND_GAS_URL = 'https://script.google.com/macros/s/AKfycbxYre4YSgLD61ekcPTnNiDR5H2ZWG2GqLEKFpPdykNgUV8MiHmCZ0OFWgytV4VD5vQv/exec';
  var ND_API_KEY = 'NeumaQuote';
  var ND_FILETYPE = 'FINAL';

  if (!ND_GAS_URL) {
    console.error('[ND Quote Final] ND_GAS_URL 未設定');
  }

  /* ---------------- 共用：讀 JSON script ---------------- */

  function j(id, fb) {
    try {
      var el = document.getElementById(id);
      if (!el) return fb;
      var txt = el.textContent || el.innerText || 'null';
      var v = JSON.parse(txt);
      return (v == null ? fb : v);
    } catch (e) {
      return fb;
    }
  }

  var CUST = j('cx2-customer-json', { id: null, email: null, tags: [] });
  var TAGS = j('cx2-tags-json', []);

  /* ---------------- 客編（6 碼 TAG） ---------------- */

  function prefixFromTags() {
    var hit = Array.isArray(TAGS)
      ? TAGS.find(function (t) { return /^[A-Za-z0-9]{6}$/.test(String(t || '').trim()); })
      : null;
    return hit ? String(hit).toUpperCase() : 'GUEST';
  }

  // 給 GAS 用的 6 碼客編（含數字 OK）
  function ndGetCustomerCode() {
    return prefixFromTags();
  }

  /* ---------------- 讀畫面上的欄位 ---------------- */

  function pickValue(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (!el) continue;
      var v = (el.value || '').trim();
      if (v) return v;
    }
    return '';
  }

  function readContactName() {
    return pickValue([
      'input[name="attributes[Shipping Contact Name]"]',
      'input[name="attributes[Contact Name]"]',
      'input[name="attributes[contact_name]"]'
    ]);
  }

  function readPhoneNumber() {
    return pickValue([
      'input[name="attributes[Shipping Phone]"]',
      'input[name="attributes[Phone Number]"]',
      'input[name="attributes[phone_number]"]'
    ]);
  }

  function readCompanyName() {
    return pickValue([
      'input[name="attributes[Company Name]"]'
    ]);
  }

  function readShippingAddress() {
    return pickValue([
      'textarea[name="attributes[Shipping Address]"]',
      'textarea[name="attributes[shipping_address]"]'
    ]);
  }

  function readReferenceNumber() {
    return pickValue([
      'input[name="attributes[Reference Number]"]',
      'input[name="attributes[reference_number]"]',
      '#Cart-reference-number',
      'input#Cart-reference-number'
    ]);
  }

  // 讀 factor（支援 attributes[Factor] / attributes[factor]）
  function readFactor() {
    var el = document.querySelector(
      '#nd-factor-input,' +
      '[name="nd-factor"],' +
      'input[data-nd-factor],' +
      'input[name="attributes[Factor]"],' +
      'input[name="attributes[factor]"]'
    );
    if (!el || typeof el.value !== 'string') return '';
    var raw = el.value.replace(/[^0-9.]/g, '');
    if (!raw) return '';
    if (raw.startsWith('.')) raw = '0' + raw;
    var n = parseFloat(raw);
    if (!isFinite(n)) return '';
    if (n < 0) n = 0;
    if (n > 9.999) n = 9.999;
    return n.toFixed(3);
  }

  function readSpecialInstruction() {
    return pickValue([
      'textarea[name="attributes[Special Instruction]"]',
      'textarea[name="attributes[Special Instructions]"]',
      'textarea#Cart-note',
      '#Cart-note'
    ]);
  }

  /* ---------------- summary：至少不要空白 ---------------- */

  function buildSummaryFromCart(cart) {
    try {
      if (!cart || !Array.isArray(cart.items)) return '';
      var parts = cart.items.map(function (it) {
        var title = String(it.product_title || it.title || '').trim();
        var qty = it.quantity || 0;
        if (!title) return '';
        return title + ' x' + qty;
      }).filter(Boolean);
      return parts.join(' | ');
    } catch (e) {
      return '';
    }
  }

  /* ---------------- 送 Final 到 GAS（form-urlencoded，等待回傳號碼） ---------------- */
  // 回傳 true = 成功並拿到 quotation_no
  // 回傳 false = 任何失敗（網路、回傳錯誤、沒 quotation_no...）

  async function sendFinalToGas() {
    if (!ND_GAS_URL) {
      console.error('[ND Quote Final] ND_GAS_URL 未設定');
      return false;
    }

    try {
      // 1) 讀 cart.js
      var cartResp = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!cartResp.ok) {
        console.error('[ND Quote Final] cart.js load failed, status=', cartResp.status);
        alert('Export / Final 失敗：無法讀取購物車 (status ' + cartResp.status + ')');
        return false;
      }
      var cart = await cartResp.json();

      console.log('[ND Quote Final] cart items length =',
        cart && Array.isArray(cart.items) ? cart.items.length : '(no items array)');

      // ===========================
      // PATCH (Route 1): collect Optis/BSS state from cart item properties
      // Save to payload_json.nd_options_state_by_variant (variant_id => state JSON string)
      // ===========================
      var ndStateMap = {};
      try {
        (cart.items || []).forEach(function (it) {
          var vid = String(it && it.variant_id || '');
          var st = it && it.properties && it.properties._nd_options_state;
          if (vid && st) ndStateMap[vid] = st;
        });
      } catch (e) {
        console.warn('[ND Quote Final] build ndStateMap failed:', e);
      }

      var payloadJsonObj = {
        cart: cart,
        nd_options_state_by_variant: ndStateMap
      };

      try {
        console.log('[ND Quote Final] nd_options_state_by_variant keys =', Object.keys(ndStateMap || {}).length);
      } catch (_) {}
      // ===========================

      // 2) 客戶資訊 / summary
      var customerEmail =
        (cart && cart.customer && cart.customer.email) ||
        (CUST && CUST.email) ||
        '';

      var summary = buildSummaryFromCart(cart);

      // 3) 讀畫面欄位
      var contactName   = readContactName();
      var phoneNumber   = readPhoneNumber();
      var companyName   = readCompanyName();
      var shippingAddr  = readShippingAddress();
      var referenceNumb = readReferenceNumber();
      var factor        = readFactor();
      var specialInst   = readSpecialInstruction();

      var customerCode = ndGetCustomerCode();
      console.log('[ND Quote Final] customer_code =', customerCode);

      // 4) 組 payload（全部用 form 參數送給 GAS）
      var payload = {
        apiKey: ND_API_KEY,
        action: 'save',
        file_type: ND_FILETYPE,

        customer_code: customerCode,

        customer_email: customerEmail,
        summary: summary,

        contact_name: contactName,
        phone_number: phoneNumber,
        reference_numb: referenceNumb,
        company_name: companyName,

        shipping_address: shippingAddr,
        shipping_addres: shippingAddr, // 相容舊欄位

        factor: factor,
        special_instruction: specialInst,

        // PATCH: payload_json now includes nd_options_state_by_variant
        payload_json: JSON.stringify(payloadJsonObj)
      };

      console.log('[ND Quote Final] FINAL payload (form) ready, sending to GAS...');

      var body = new URLSearchParams(payload).toString();

      var resp = await fetch(ND_GAS_URL, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: body
      });

      if (!resp.ok) {
        console.error('[ND Quote Final] GAS response not OK, status=', resp.status);
        alert('Export / Final 失敗：GAS 連線錯誤 (status ' + resp.status + ')');
        return false;
      }

      var data;
      try {
        data = await resp.json();
      } catch (e) {
        console.error('[ND Quote Final] parse JSON error:', e);
        alert('Export / Final 失敗：GAS 回傳格式錯誤');
        return false;
      }

      if (!data || !data.ok) {
        console.error('[ND Quote Final] GAS returned error:', data && (data.error || data.message));
        alert('Export / Final 失敗：' + (data && (data.error || data.message) || 'Unknown error'));
        return false;
      }

      var qNo = data.quotation_no ? String(data.quotation_no).trim() : '';
      if (!qNo) {
        console.warn('[ND Quote Final] GAS did not return quotation_no');
        alert('Export / Final 失敗：GAS 沒有回傳 quotation_no');
        return false;
      }

      // ★ 把 GAS 回傳的正式號碼寫入全域，給 PDF / Excel 使用
      var info = {
        quotation_no: qNo,
        customer_code: customerCode,
        row_id: data.row_id || '',
        status: data.status || '',
        draft_name: data.draft_name || ''
      };

      window.ND_QUOTE_FINAL_INFO = info;
      window.ND_QUOTE_SERIAL_FULL = qNo;
      window.ND_LAST_FINAL_QUOTE = info;

      console.log('[ND Quote Final] got quotation_no from GAS:', qNo);

      return true;
    } catch (err) {
      console.error('[ND Quote Final] ERROR preparing/sending FINAL payload:', err);
      alert('Export / Final 失敗：' + (err && err.message ? err.message : String(err)));
      return false;
    }
  }

  /* ---------------- 綁定「Export File / Export your quote」按鈕 ---------------- */

  document.addEventListener('click', function (ev) {
    try {
      // 只攔截「使用者真的點」的事件；程式觸發的二次 click 直接略過
      if (!ev.isTrusted) return;

      var el = ev.target && ev.target.closest &&
        ev.target.closest('button, a, [role="button"], input[type="button"], input[type="submit"]');
      if (!el) return;

      var txt = ((el.textContent || el.value || '') + '').toLowerCase();

      // 只抓有 "export" 字樣的按鈕（避免 Save Draft 被誤觸）
      if (txt.indexOf('export file') === -1 && txt.indexOf('export') === -1) {
        return;
      }

      console.log('[ND Quote Final] export button click detected (capture phase):', el);

      // 暫停原本的 click 流程，等我們跟 GAS 把 FINAL 跑完
      ev.preventDefault();
      ev.stopPropagation();
      if (typeof ev.stopImmediatePropagation === 'function') {
        ev.stopImmediatePropagation();
      }

      // 非同步處理：先送 Final 到 GAS，成功後再觸發一次程式 click 給其他腳本用
      (async function () {
        try {
          // 避免重複點擊
          var oldDisabled = el.disabled;
          try { el.disabled = true; } catch (_) {}

          var ok = await sendFinalToGas();

          try { el.disabled = oldDisabled; } catch (_) {}

          if (!ok) {
            console.warn('[ND Quote Final] sendFinalToGas() failed, aborting export pipeline.');
            return;
          }

          console.log('[ND Quote Final] GAS finalized, triggering export scripts.');

// ✅ 1) 先照原本流程，讓 PDF / 其他 export script 照常吃到 click
var evt = new MouseEvent('click', {
  bubbles: true,
  cancelable: true,
  view: window
});
el.dispatchEvent(evt);

// ✅ 2) XLSX 不走 click（會被 isTrusted 擋），直接呼叫
if (typeof window.__ND_onClickXlsx === 'function') {
  console.log('[ND Quote Final] calling XLSX exporter directly');
  window.__ND_onClickXlsx(el);
} else {
  console.warn('[ND Quote Final] XLSX exporter not found');
}

        } catch (e) {
          console.error('[ND Quote Final] async export pipeline error:', e);
        }
      })();
    } catch (e) {
      console.error('[ND Quote Final] click handler error:', e);
    }
  }, true); // ★ true = 捕獲階段

})();
